export const US_STATES = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'District of Columbia',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming'
];

export const US_PRODUCT_RULES = {
  'prepared-ii': {
    blockedStates: [
      'Colorado',
      'District of Columbia',
      'Minnesota',
      'Mississippi',
      'Montana',
      'New Hampshire',
      'New Mexico',
      'Rhode Island',
      'South Dakota',
      'Virginia',
      'Vermont',
      'Georgia',
      'Oregon',
      'Massachusetts',
      'Utah'
    ],
    noteLines: [
      'Prepared II is not available for sale in CO, DC, MA, MN, MS, MT, NH, NM, RI, SD, UT, VA, VT.',
      'Prepared II consumer materials are not approved for use in GA and OR.'
    ],
    caVariants: false
  },
  planright: {
    blockedStates: ['Massachusetts', 'Utah'],
    noteLines: ['PlanRight is not available for sale in MA or UT.'],
    caVariants: false
  },
  flwp: {
    blockedStates: ['Nevada', 'Mississippi'],
    noteLines: [
      'Foresters Live Well Plus consumer materials are not approved for use in NV and MS.'
    ],
    caVariants: false
  },
  'advantage-plus-ii': {
    blockedStates: ['Nevada', 'Mississippi'],
    noteLines: ['Advantage Plus II consumer materials are not approved for use in NV.'],
    caVariants: true
  },
  'smart-ul': {
    blockedStates: ['Nevada', 'Mississippi'],
    noteLines: ['SMART UL consumer materials are not approved for use in NV and MS.'],
    caVariants: true
  },
  'your-term': {
    blockedStates: ['Oregon'],
    noteLines: ['Your Term consumer materials are not approved for use in OR.'],
    caVariants: true
  },
  'strong-foundation': {
    blockedStates: ['Oregon'],
    noteLines: ['Strong Foundation consumer materials are not approved for use in OR.'],
    caVariants: true
  },
  brightfuture: {
    blockedStates: ['Washington'],
    noteLines: ['BrightFuture consumer materials are not approved for use in WA.'],
    caVariants: false
  }
};

export const US_VARIANT_LABELS = {
  standard: 'US',
  ca: 'California'
};

export const US_COMPLIANCE_CODES = {
  'prepared-ii': {
    standard: {
      en: {
        male: '506825 US 01/26',
        female: '506826 US 01/26'
      },
      es: {
        male: '506827 SP 01/26',
        female: '506828 SP 01/26'
      }
    }
  },
  planright: {
    standard: {
      en: {
        male: '506841 US 01/26',
        female: '506842 US 01/26'
      },
      es: {
        male: '506843 SP 01/26',
        female: '506844 SP 01/26'
      }
    }
  },
  flwp: {
    standard: {
      en: {
        male: '506833 US 01/26',
        female: '506834 US 01/26'
      },
      es: {
        male: '506835 SP 01/26',
        female: '506836 SP 01/26'
      }
    }
  },
  'advantage-plus-ii': {
    standard: {
      en: {
        male: '506829 US 01/26',
        female: '506830 US 01/26'
      },
      es: {
        male: '506831 SP 01/26',
        female: '506832 SP 01/26'
      }
    },
    ca: {
      en: {
        male: '506898 CA 01/26',
        female: '506899 CA 04/26'
      },
      es: {
        male: '506900 CA SP 01/26',
        female: '506901 CA SP 01/26'
      }
    }
  },
  'smart-ul': {
    standard: {
      en: {
        male: '506845 US 01/26',
        female: '506846 US 01/26'
      },
      es: {
        male: '506847 SP 01/26',
        female: '506848 SP 01/26'
      }
    },
    ca: {
      en: {
        male: '506902 CA 01/26',
        female: '506903 CA 01/26'
      },
      es: {
        male: '506904 CA SP 01/26',
        female: '506905 CA SP 01/26'
      }
    }
  },
  'your-term': {
    standard: {
      en: {
        male: '506817 US 01/26',
        female: '506818 US 01/26'
      },
      es: {
        male: '506819 SP 01/26',
        female: '506820 SP 01/26'
      }
    },
    ca: {
      en: {
        male: '506906 CA 01/26',
        female: '506907 CA 01/26'
      },
      es: {
        male: '506908 CA SP 01/26',
        female: '506909 CA SP 01/26'
      }
    }
  },
  'strong-foundation': {
    standard: {
      en: {
        male: '506821 US 01/26',
        female: '506822 US 01/26'
      },
      es: {
        male: '506823 SP 01/26',
        female: '506824 SP 01/26'
      }
    },
    ca: {
      en: {
        male: '506910 CA 01/26',
        female: '506911 CA 01/26'
      },
      es: {
        male: '506912 CA SP 01/26',
        female: '506913 CA SP 01/26'
      }
    }
  },
  brightfuture: {
    standard: {
      en: {
        male: '506837 US 01/26',
        female: '506838 US 01/26'
      },
      es: {
        male: '506839 SP 01/26',
        female: '506840 SP 01/26'
      }
    }
  }
};

export const CA_CONTRACTING_FILTERS = {
  foresters: {
    hide: ['express-elite', 'a-z-life-coverage', 'critical-illness']
  },
  cpp: {
    hide: ['foresters-term', 'advantage-plus', 'advantage-max', 'live-well-plus']
  },
  both: {
    hide: []
  }
};

export const LANGUAGE_OPTIONS = {
  us: [
    { value: ['en'], label: 'English' },
    { value: ['es'], label: 'Spanish' },
    { value: ['en', 'es'], label: 'English and Spanish' }
  ],
  ca: [
    { value: ['en'], label: 'English' },
    { value: ['fr'], label: 'French' },
    { value: ['en', 'fr'], label: 'English and French' }
  ]
};
